.container {
    min-width: 230px;
    min-height: 700px;
}

.content {
    padding: 56px 16px;
    grid-template-rows: auto 1fr auto 1fr;
}
